import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

function isTokenUsable(token) {
  if (!token) return false;
  try {
    const { exp } = JSON.parse(atob(token.split(".")[1]));
    // Allow up to 24 h past expiry — matches the server's refresh grace window
    return !exp || Date.now() < (exp + 86400) * 1000;
  } catch {
    return false;
  }
}

const PrivateRoute = () => {
  const token = useSelector((state) => state.auth.token);
  return isTokenUsable(token) ? <Outlet /> : <Navigate to="/signin" replace />;
};

export default PrivateRoute;
